/** How one kind of debris burst is thrown: every range is [low, high], picked per cube. */
export interface BurstSpec {
  /** Horizontal speed, m/s (multiplied by the burst's reach). */
  speed: readonly [number, number];
  up: readonly [number, number];
  size: readonly [number, number];
  life: readonly [number, number];
}

export const BURSTS = {
  impact: { speed: [0.6, 2.4], up: [2.2, 4.2], size: [0.09, 0.14], life: [0.45, 0.7] },
  blood: { speed: [0.5, 1.8], up: [1.2, 2.8], size: [0.1, 0.13], life: [0.4, 0.6] },
  blast: { speed: [0.7, 1.7], up: [5, 9], size: [0.12, 0.24], life: [1.4, 2.0] },
  bigBlast: { speed: [0.7, 1.8], up: [6.5, 11], size: [0.14, 0.34], life: [1.6, 2.2] },
  wreck: { speed: [2, 6], up: [4, 8.5], size: [0.18, 0.42], life: [1.6, 2.4] },
} as const satisfies Record<string, BurstSpec>;
